import { Component, OnInit, Inject } from '@angular/core';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { GradeBookStandards, AssignmentsDTO, GradeBookObjectives } from '../assignment.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AssignmentService } from '../assignment.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'app-standards-based-scores',
    templateUrl: './standards-based-scores.component.html',
    styles: []
})
export class StandardsBasedScoresComponent implements OnInit {

    siteSectionId: number;
    course: CourseSchedule;
    teacherName: string;
    startDate: Date;
    endDate: Date;
    termId: number;
    gradebookStandard: GradeBookStandards[];
    standardsBasedHeader: any = {};
    studentAssignments: AssignmentsDTO[] = [];
    gradebookObjectives: GradeBookObjectives[] = [];
    V10Flag = false;
    selectedOrderByOption = 3;
    assignmentSortBy = '-StandardDate';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogBox: MatDialogRef<StandardsBasedScoresComponent>,
        private assignmentService: AssignmentService,
        private studentService: StudentService,
        private yearService: YearService,
        private loginService: LoginService
    ) { }

    ngOnInit() {
        this.V10Flag = this.loginService.LoginSettings.V10;
        this.siteSectionId = this.data.siteSectionId;
        this.teacherName = this.data.teacherName;
        this.course = this.data.course;
        this.termId = this.data.termId;
        this.startDate = this.data.startDate;
        this.endDate = this.data.endDate;
        this.studentAssignments = this.data.studentAssignments;
        this.getStandardsBasedHeader();
    }

    getStandardsBasedHeader() {
        this.assignmentService.getStandardsBasedHeader(this.siteSectionId, this.startDate, this.endDate, this.termId).subscribe(data => {
            this.gradebookStandard = data;
            this.gradebookStandard.sort();
            this.getGradebookObjective(this.studentAssignments);
        });
    }

    getGradebookObjective(studentAssignments: AssignmentsDTO[]) {
        this.gradebookObjectives = [];
        if (studentAssignments.length > 0) {
            studentAssignments.filter(o => o.ShowStandardBasedScore == true).forEach(obj => {
                if (obj.GradeBookObjectives != null) {
                    const gradebookObj = obj.GradeBookObjectives;
                    gradebookObj.forEach(grd => {
                        if (this.gradebookObjectives.length == 0) {
                            this.gradebookObjectives.push(grd);
                        }
                        else if (this.gradebookObjectives.filter(o => o.Id == grd.Id).length == 0) {
                            this.gradebookObjectives.push(grd);
                        }
                        if (this.gradebookStandard.filter(o => o.GradeBookAssignmentId == grd.AssignmentId).length == 0) {
                            this.gradebookStandard = [];
                            this.standardsBasedHeader = {};
                            this.standardsBasedHeader.CurriculumCourseObjectiveId = grd.Id;
                            this.standardsBasedHeader.GradeBookAssignmentId = obj.AssignmentId;
                            this.standardsBasedHeader.Id = obj.Assignment;
                            this.standardsBasedHeader.ParentId = -1;
                            this.standardsBasedHeader.Score = 0;
                            this.standardsBasedHeader.Standard = obj.AssignmentShortName;
                            this.standardsBasedHeader.StandardDate = obj.DueDate;
                            this.gradebookStandard.push(this.standardsBasedHeader);
                        }
                    });
                }
            });
        }
    }

    cancel() {
        this.dialogBox.close();
    }

    getCellValues(gradebookObj: GradeBookObjectives, standard: GradeBookStandards) {
        let scores = '';
        if (this.studentAssignments.filter(o => o.AssignmentId == standard.GradeBookAssignmentId).length > 0) {
            const gradebookObjectiveRow = this.studentAssignments.filter(o => o.AssignmentId == standard.GradeBookAssignmentId)[0].GradeBookObjectives;
            if (gradebookObjectiveRow != null && gradebookObjectiveRow.filter(x => x.Id == gradebookObj.Id).length > 0) {
                const standardsBasedScore = gradebookObjectiveRow.filter(x => x.Id == gradebookObj.Id)[0].StandardsBasedScores;
                if (this.V10Flag) {
                    if (standardsBasedScore != null && standardsBasedScore.filter(a => a.CurriculumCourseObjectiveId == gradebookObj.Id && a.GradeBookAssignmentId == standard.GradeBookAssignmentId).length > 0) {
                        scores = standardsBasedScore.filter(a => a.CurriculumCourseObjectiveId == gradebookObj.Id && a.GradeBookAssignmentId == standard.GradeBookAssignmentId)[0].V10Score;
                    }
                }
                else {
                    if (standardsBasedScore != null && standardsBasedScore.filter(a => a.CurriculumCourseObjectiveId == gradebookObj.Id && a.Id == standard.Id).length > 0) {
                        if (standardsBasedScore.filter(a => a.CurriculumCourseObjectiveId == gradebookObj.Id && a.Id == standard.Id)[0].Score != '-1') {
                            scores = standardsBasedScore.filter(a => a.CurriculumCourseObjectiveId == gradebookObj.Id && a.Id == standard.Id)[0].Score.toString();
                        }
                    }
                }
            }
        }

        return scores;
    }

    getV10Score(standard, assignment) {
        let assignmentStandard = assignment.GradeBookObjectives.filter(s => s.Id == standard.Id)[0];
        if (assignmentStandard) {
            let score = assignmentStandard.StandardsBasedScores[0];
            return (score) ? score.V10Score : '';
        }
    }

    selectedTermChange() {
        this.studentAssignments = [];
        this.gradebookObjectives = [];
        if (this.termId == 0) {
            this.startDate = this.course.CourseTerms[0].StartDate;
            this.endDate = this.course.CourseTerms[this.course.CourseTerms.length - 1].EndDate;
        }
        else {
            this.startDate = this.course.CourseTerms.filter(o => o.Id == this.termId)[0].StartDate;
            this.endDate = this.course.CourseTerms.filter(o => o.Id == this.termId)[0].EndDate;
        }
        this.assignmentService.getStudentAssignments(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, this.siteSectionId, this.startDate, this.endDate, this.termId, this.studentService.studentEnrollment.SiteYearId).subscribe(data => {
            this.studentAssignments = data;
            data.forEach(obj => {
                this.studentAssignments.push(obj);
            });
            this.getStandardsBasedHeader();
            this.getGradebookObjective(this.studentAssignments);
        });
    }

    selectedOrderByOptionChanged() {
        switch (this.selectedOrderByOption) {
            case 1:
                this.assignmentSortBy = 'Standard';
                break;
            case 2:
                this.assignmentSortBy = '-Standard';
                break;
            case 3:
                this.assignmentSortBy = '-StandardDate';
                break;
            case 4:
                this.assignmentSortBy = 'StandardDate';
                break;
            default:
                this.assignmentSortBy = 'StandardDate';
                break;
        }
    }
}
